import { Box } from '@mui/material';
import { SetOptional } from 'type-fest';

import {
  FormAwareButtonGroup,
  FormAwareButtonGroupProps,
} from '@/components/form/formAwareInputs/FormAwareButtonGroup';

import { CommonHypotheticalTransferFormShape } from './estateWaterfallHypotheticalTransfers.types';

export const DollarPercentValues = {
  DOLLAR: 'amount',
  PERCENT: 'percent',
} as const;

export type DollarPercentPattern =
  (typeof DollarPercentValues)[keyof typeof DollarPercentValues];

export function DollarPercentButtonGroup<
  FormShape extends CommonHypotheticalTransferFormShape,
>(props: SetOptional<FormAwareButtonGroupProps<FormShape>, 'options'>) {
  return (
    <Box width={80}>
      <FormAwareButtonGroup
        variant="light"
        options={[
          { display: '$', value: DollarPercentValues.DOLLAR },
          { display: '%', value: DollarPercentValues.PERCENT },
        ]}
        {...props}
      />
    </Box>
  );
}
